import React, { useRef, useEffect } from 'react';
import './css/Main.css';

const MysteryForm = ({ onSubmit, onChange, code, error, isLoading }) => {
  const fieldRef = useRef(null);

  useEffect(() => {
    let intervalId;

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [onSubmit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        maxWidth: '400px',
        margin: '0 auto',
        padding: '16px',
      }}
      autoComplete="off"
      spellCheck="false"
      onSubmit={handleSubmit}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', width: '100%' }}>
        <input
          ref={fieldRef}
          name="code"
          type="text"
          style={{
            width: '105%',
            padding: '8px',
            fontSize: '16px',
            borderRadius: '8px',
            border: '1px solid white',
            backgroundColor: 'black',
            color: 'white',
            textAlign: 'center',
            boxSizing: 'border-box',
          }}
          value={code}
          onChange={onChange}
        />
        <input
          name="submit"
          type="submit"
          className="submit-button"
          value="Submit"
          disabled={isLoading}
        />
      </div>
    </form>
  );
};

export default MysteryForm;
